<template>
    <v-container>
        <v-card class="text-center">
            <v-card-text class="pt-5 pb-4 mb-1">
                <h4>Det er for øyeblikket ingen dekk lagret for denne bilen.</h4>
                <p>Vil du opprette en ny dekklagring?</p>
            </v-card-text>
            <v-card-actions class="grey lighten-4">
                <v-spacer/>
                <v-btn color="green" text @click="newStorage(null)">
                    <v-icon left>add_circle</v-icon>
                    Ny dekklagring
                </v-btn>
                <v-tooltip v-for="storage in mostRecentByType" bottom :key="storage.id">
                    <v-btn slot="activator" :color="`${storage.type_color} darken-2`" text :key="storage.id"
                           @click="newStorage(storage)">
                        <v-icon left>{{ storage.type_icon }}</v-icon>
                        Kopier {{ storage.brand }} {{ storage.type_text }}
                    </v-btn>
                    Ble sist {{ formatStorageTime(storage).toLowerCase() }}
                </v-tooltip>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {formatStorageTime} from "../../helpers";

    export default {
        data() {
            return {
                mostRecentByType: {}
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            formatStorageTime,
            loadData() {
                let params = {car: this.carId};

                this.$http.get('tire-storages', {params}).then(response => {
                    let mostRecentByType = {};
                    response.data.data.forEach(it => {
                        if (!mostRecentByType[it.type] || it.out_at > mostRecentByType[it.type]) {
                            mostRecentByType[it.type] = it;
                        }
                    });

                    this.mostRecentByType = mostRecentByType;
                });
            },
            newStorage(baseStorage) {
                this.$router.push({
                    name: 'TireStorageCreate',
                    params: {
                        id: this.carId,
                        base: baseStorage
                    }
                });
            }
        },

        computed: {
            carId() {
                return this.$route.params.id;
            }
        }
    }
</script>
